import React from "react";
import { Text } from "@bookingcom/bui-react";
import { useI18n } from "@bookingcom/lingojs-react";
import { t } from "@bookingcom/lingojs-core";
import useGlobalContext from "../hooks/useGlobalContext.js";
import styles from "./NoJS.module.css";
export default function NoJS() {
    const i18n = useI18n();
    const { env, userAgent } = useGlobalContext();
    return env === "prod" && !userAgent.isBot ? (React.createElement("noscript", { className: styles.root },
        React.createElement(Text, { variant: "headline_3" }, i18n.trans(t("flights_error_js_header"))),
        React.createElement(Text, { variant: "featured_2" }, i18n.trans(t("flights_error_js_sub"))))) : (React.createElement(React.Fragment, null));
}
